import { useFormik } from "formik";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { formikinitialvalues, replaceUnderscore } from "../../../../../CommonFunction/common";
import { updateFormData } from "../../../../../Store/FormDataReducer/FormFieldFunctions";
import Input from "../../../../Components/Input/Input";
import Button from "../../../Button/Button";
import { Formik_Vschema } from "../../../FormInputSectionComponent/Validation";
// const { useQuery, gql, useLazyQuery } = require("@apollo/client");

const Addloadsection = ({
  inputfields,
  Type,
  ShowVehicleCategory,
  isVehicleCateSelected,
  fielddata,
  BidType,
  TypeOfPortal,
  handleOpenSelectionModal,
  formkey,
  setAllFieldsData,
  onErrorsChange = (newErrors) => {},
  setFirstLoad=()=>{}
}) => {
  const [fields, setfields] = useState(inputfields);
  const [alldata, setalldata] = useState({});
  const [VehicleCategory, setVehicleCategory] = useState(ShowVehicleCategory);
  const FormData = useSelector((store) => store.FormFieldData);
  const [FieldData, setFieldData] = useState(fielddata);
  const dispatch = useDispatch();
  const FormDataFromRedux = useSelector((store) => store?.FormDataReducer);

  const prevErrorsRef = useRef();
  useEffect(() => {
    setVehicleCategory(ShowVehicleCategory);
  }, [ShowVehicleCategory]);

  useEffect(() => {
    setfields(inputfields);
  }, [inputfields]);

  useEffect(() => {
    setFieldData(fielddata);
  }, [fielddata]);

  // useEffect(() => {
  //   setOdc(fielddata2?.Material_Details && fielddata2.Material_Details.Over_Dimension_Cargo);

  //   formik.setFieldValue();
  // }, [fielddata2]);

  let From_Location = FormDataFromRedux?.MasterData[formkey]?.Loading_Name;

  useEffect(() => {
    if (Type === "Loading_Point" && From_Location) {
      setFieldData({
        ...fielddata,

        Loading_State: From_Location.administrativeAreaLevel1,
        Loading_City: From_Location.city || From_Location.locality || From_Location.Search_Value,
        Loading_Address_Line_1: From_Location.formattedAddress,
        Loading_Landmark: From_Location.locality || From_Location?.name,
        Loading_Pincode: Number(From_Location.pincode) || Number(From_Location.postalCode),
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [FormDataFromRedux?.MasterData[formkey]?.Loading_Name]);

  let To_Location = FormDataFromRedux?.MasterData[formkey]?.Unloading_Name;

  useEffect(() => {
    if (Type === "Unloading_Point" && To_Location) {
      setFieldData({
        ...fielddata,

        Unloading_State: To_Location.administrativeAreaLevel1,
        Unloading_City: To_Location.city || To_Location.locality || To_Location.Search_Value,
        Unloading_Address_Line_1: To_Location.formattedAddress,
        Unloading_Landmark: To_Location.locality || To_Location.name,
        Unloading_Pincode: Number(To_Location.pincode) || Number(To_Location.postalCode),
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [FormDataFromRedux?.MasterData[formkey]?.Unloading_Name]);

  useEffect(() => {
    if (FieldData) {
      let arr = [];
      for (var a = 0; a < fields?.length; a++) {
        arr.push({ [fields[a].name]: FieldData[fields[a].name] });
        formik.setFieldValue(fields[a].name, FieldData[fields[a].name]);
      }
      let obj = {};

      for (var l = 0; l < arr.length; l++) {
        let temp = arr[l];
        for (var key in temp) {
          obj[key] = temp[key];
        }
      }
      if (obj) {
        setalldata(obj);
      }
    } else {
      let arr = [];

      let obj = {};

      for (var l = 0; l < arr.length; l++) {
        let temp = arr[l];
        for (var key in temp) {
          obj[key] = temp[key];
        }
      }
      if (obj) {
        setalldata(obj);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [FieldData, fields]);

  useEffect(() => {
    // if (alldata.Over_Dimension_Cargo === "No") {
    //   alldata.Material_Dimension = "";
    //   alldata.Material_Dimension_In = "";
    // }

    dispatch({
      type: "Add_FormFieldData",
      payload: { data: alldata, key: Type },
    });
    updateFormData(dispatch, formkey, Type, alldata);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [alldata]);

  const validate = (values) => {
    setalldata(values);
  };

  const determineVisibility = (field) => {
    if (field.dependOn) {
      const { section, name, visibleOn } = field.dependOn;
      const dependentSection = FormData.fielddata && FormData.fielddata[section];
      if (dependentSection && dependentSection[name] === visibleOn) {
        return true;
      } else if (dependentSection && dependentSection[name]) {
        let key = field.name;

        if (alldata[key]) {
          delete alldata[key];
          formik.setFieldValue(key, "");
          setalldata({ ...alldata });
        }
        return false;
      }
      return false;
      // return dependentSection && dependentSection[name] === visibleOn;
    }
    return true; // Fields without a dependOn property are always visible
  };

  // validationSchema: Formik_Vschema(fields),
  const formik = useFormik({
    initialValues: formikinitialvalues(fields),
    validationSchema: Formik_Vschema(inputfields),
    validate,
    onSubmit: (values) => {},
  });

  const handleInputChange = (evt) => {
    
    setFirstLoad(curr => {
      return curr || true;
    });
    formik.handleChange(evt);
  };

  useEffect(() => {
    dispatch({
      type: "Form_Errors",
      payload: { data: formik.errors, key: Type },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik.errors, formik.values]);

  useEffect(() => {
    if (prevErrorsRef.current !== formik.errors) {
      const Err_Type = Type;
      const errors = { [Err_Type]: formik.errors };
      onErrorsChange(errors);
      prevErrorsRef.current = formik.errors;
    }
  }, [formik.errors, onErrorsChange, Type, formik.values]);

  useEffect(() => {
    formik.validateForm();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!TypeOfPortal?.toLowerCase().includes("add")) {
      formik.validateForm();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik.values]);

  return (
    <div className="Addloadsection">
      {Type !== "Bidding_Fields" &&
        Type !== "Vehicle_Fields" &&
        Type !== "Vehicle_Fields2" &&
        Type !== "Vehicle_Fields3" &&
        Type !== "Note_Data" && <div className="headingaddloadsection">{replaceUnderscore(Type)}</div>}

      {fields?.length > 0 && (
        <form onSubmit={formik.handleSubmit} autoComplete="off">
          <div className="contentAddload">
            {fields?.map((e) => {
              if (!determineVisibility(e)) {
                return null;
              }

              if (e.name === "Vehicle_Category") {
                return (
                  <div className={"selectvehiclebtn"}>
                    <Button
                      name="modalbutton"
                      text={isVehicleCateSelected ? "Selected Vehicle" : "Select Vehicle"}
                      action={() => handleOpenSelectionModal()}
                      type={""}
                      children={""}
                      disabled={FormData?.fielddata?.Load_Type?.Load_Type === "PTL (Part Load)"}
                    ></Button>


                    {VehicleCategory &&
                      VehicleCategory?.map((item, index) => (
                        <p className="loadfromvehicleDetails">
                          <div className="VTData">
                            <div>
                              {`${index + 1}. ${item.VehicleType} -`}
                              {index < VehicleCategory.length - 1 ? "\n" : ""}{" "}
                            </div>
                            <div>
                              {item?.VehicleCategory?.map((category, index) => (
                                <div>
                                  {category.Name}
                                  {index < item.VehicleCategory.length - 1 ? "," : ""}
                                </div>
                              ))}
                            </div>
                          </div>
                        </p>
                      ))}
                  </div>
                );
              }

              return (
                <div key={e.id}>
                  <Input
                    checked={""}
                    InputConfig={e}
                    TypeOfPortal={TypeOfPortal}
                    name={e.name}
                    id={e.name}
                    disabled={e.name === "Bid" && BidType ? true : e.disable}
                    value={
                      alldata[e.name] === undefined ? "" : alldata[e.name]
                      // || formik.values[e.name]
                    }
                    label={e.label}
                    className={"inputwidthAddload"}
                    type={e.type}
                    modalform={true}
                    Iconinside={true}
                    EMTQuery={e.EMTQuery}
                    handleInputChange={handleInputChange}
                    // handelformikdata={handelformikdata}
                    dropdowndata={e.dropdowncontent}
                    hasApiCallback={e.hasApiCallback}
                    handleBlur={formik.handleBlur}
                    touched={formik.touched[e.name]}
                    error={formik.errors[e.name]}
                    min={e.min ? e.min : undefined}
                    max={e.max ? e.max : undefined}
                    notSearchable={e.notSearchable}
                    formkey={formkey}
                    fielddata={fielddata}
                    setAllFieldsData={setAllFieldsData}
                  />
                </div>
              );
            })}
          </div>
        </form>
      )}
    </div>
  );
};

export default Addloadsection;
